import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionDiyTabPopUp from "./component";
import { withRouter } from "react-router-dom";

const mapStateToProps = ({
    postInspectionDiy: {
        inspectionResponse,
        postTokenDocuments,
        priceBreakup,
        pickupDetail,
        showSelfBought,
        franchiseDetails
    }
}) => ({
    inspectionResponse,
    postTokenDocuments,
    priceBreakup,
    pickupDetail,
    showSelfBought,
    franchiseDetails
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyTabPopUp));
